export const uk = {
    'new-video': 'Новое видео'
};
